import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { AppComponent } from 'src/app/app.component';
import { PagoModule } from 'src/app/pago/pago.module';
import {
  DynatraceModule,
  HEADERS_INJECTED,
  InjectHeadersHttpClient,
  PrismicGraphqlService,
  SuraFormatAddressService,
  TenantModule,
} from '@segurosvoluntarios_vel/commons-services';
import { ARRAY_OF_TENANTS } from 'src/app/pago/tenants';
import { SuraLayoutModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-layout';
import { PagoFacade } from 'src/app/pago/services/pago-facade/pago.facade';
import { StoreModule } from '@ngrx/store';
import { reducers } from 'src/app/store/reducers/app-reducer/app.reducer';
import { getInitialState } from 'src/app/store/state/app.state';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { effectsArray } from 'src/app/store/effects/app-effect/app.effect';
import { FooterComponent } from 'src/app/pago/components/footer/footer.component';
import { TenantManagerService } from 'src/app/pago/services/tenan-manager/tenant-manager.service';
import { LoadingScreenModule } from '@segurosvoluntarios_vel/lib-angular-components/src/sura-loading-screen';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';
import { MaestroFacade } from 'src/app/pago/services/maestro-facade/maestro.facade';
import { HTTP_INTERCEPTORS, HttpHeaders } from '@angular/common/http';
import { headerAzure } from 'src/app/shared/utils/httpClientHeaders.utils';
import { CommonComponentsModule } from '@segurosvoluntarios_vel/lib-angular-components';
import { ErrorCatchingInterceptor } from 'src/app/shared/interceptors/error-catching.interceptor';
@NgModule({
  declarations: [AppComponent, FooterComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    TenantModule.forRoot(ARRAY_OF_TENANTS),
    EffectsModule.forRoot(effectsArray),
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
      initialState: getInitialState(),
    }),
    LoadingScreenModule,
    StoreDevtoolsModule.instrument(),
    SuraLayoutModule,
    PagoModule,
    AppRoutingModule,
    CommonComponentsModule,
    DynatraceModule,
  ],
  providers: [
    PagoFacade,
    MaestroFacade,
    TenantManagerService,
    CookieService,
    SuraFormatAddressService,
    PrismicGraphqlService,
    {
      provide: 'addressUrl',
      useValue: environment.suraApi,
    },
    {
      provide: HEADERS_INJECTED,
      useValue: headerAzure,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InjectHeadersHttpClient,
      multi: true,
    },
    {
      provide: 'logsApi',
      useValue: environment.logsApi,
    },
    {
      provide: 'headersLog',
      useValue: new HttpHeaders({
        [environment.headerSuscripcionNombre]:
          environment.headerSuscripcionValor,
      }),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorCatchingInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
